import styled from 'styled-components';

export const TooltipContainer = styled.div`
  position: relative;
`;

export const TooltipContent = styled.div`
  position: absolute;
  top: 50%;
  right: 78px;
  min-width: 521px;
  height: 88px;
  border-radius: 8px;
  background: #fff8ec;
  padding: 12px;
  z-index: 99;
  transform: translateY(-50%);
  box-shadow: 0px 4px 8px 0px #00000024;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TooltipIcon = styled.div`
  width: 52px;
  height: 52px;
  border: 1px solid #ed9500;
  border-radius: 8px;
  background: #fff8ec;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.span`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
`;

export const Text = styled(Title)`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
`;

export const TooltipArrow = styled.div`
  position: absolute;
  top: 50%;
  right: -16px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 16px solid #fff8ec;
  transform: translateY(-50%);
`;
